import { type FunctionComponent } from "react";

import { BaseLink } from "shared/components/common/base-link";

import { pathname as plusPathname } from "scmp-app/pages/plus";

import {
  StyledAuthorPlusFlag as StyledAuthorPlusFlagBase,
  StyledTopicPlusFlag as StyledTopicPlusFlagBase,
} from "./styles";

export type PlusFlagProps = {
  pgtype: "author" | "topic";
};

export const PlusFlag: FunctionComponent<PlusFlagProps> = ({ pgtype }) => (
  <BaseLink
    isAnchor
    pathname={plusPathname}
    query={{
      module: "plus_label",
      pgtype,
    }}
  >
    {pgtype === "author" ? <StyledAuthorPlusFlagBase /> : <StyledTopicPlusFlagBase />}
  </BaseLink>
);
